/**
 * Truncates text from the beginning if it exceeds the maximum length.
 * Adds ellipsis at the truncation point.
 *
 * @param text - The text to truncate
 * @param maxLength - Maximum length of the output (default: 41)
 * @returns An object containing the truncated text and a flag indicating if truncation occurred
 *
 * @example
 * reverseTruncate('very/long/path/to/some/file.txt', 20)
 * // Returns: { text: '…th/to/some/file.txt', truncated: true }
 */
export function reverseTruncate(
  text: string | null | undefined,
  maxLength = 41,
): {
  text: string
  truncated: boolean
} {
  if (!text || text.length <= maxLength) {
    return {text: text ?? '', truncated: false}
  }

  // Reserve 1 character for the ellipsis
  const targetLength = maxLength - 1
  const truncated = text.slice(-targetLength)

  return {text: `…${truncated}`, truncated: true}
}
